import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import LinkWrapper from '../../components/LinkWrapper';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from '../FrequentlyAskedQuestions';
import { getAcademyUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic } from '../FrequentlyAskedQuestionsPublicPageUrls';
import { useFaqToggleHandler, useLinkClickHandler } from '../FrequentlyAskedQuestionsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CREDITS_PAGE_URL = 'https://www.hubspot.com/products/artificial-intelligence/credits';
export const HsocV2Faqs = ({
  onLinkClick,
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  const handleLinkClick = useLinkClickHandler(onLinkClick);
  const languageHref = getLanguagesUrlPublic();
  const communityHref = getCommunityUrlPublic();
  const academyHref = getAcademyUrlPublic();
  const kbHref = getKnowledgeBaseUrlPublic();
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    maxInlineSize: "1200px",
    margin: "auto",
    children: /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
      children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyUsers.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyUsers.answer"
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.howManyUsers', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyUsers.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howMuchAdditionalSeatsCost.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howMuchAdditionalSeatsCost.answer"
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.howMuchAdditionalSeatsCost', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.howMuchAdditionalSeatsCost.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatAreHubSpotCredits.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatAreHubSpotCredits.answer",
          options: {
            creditsPageLink: /*#__PURE__*/_jsx(LinkWrapper, {
              href: CREDITS_PAGE_URL,
              external: true,
              onClick: () => handleLinkClick('hsocV2.whatAreHubSpotCredits.creditsPage', CREDITS_PAGE_URL),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatAreHubSpotCredits.creditsPage"
              })
            })
          }
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.whatAreHubSpotCredits', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.whatAreHubSpotCredits.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyCredits.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyCredits.answer"
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.howManyCredits', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyCredits.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howDoIBuyAdditionalCredits.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howDoIBuyAdditionalCredits.answer"
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.howDoIBuyAdditionalCredits', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.howDoIBuyAdditionalCredits.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.doINeedOnboarding.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.doINeedOnboarding.answer"
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.doINeedOnboarding', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.doINeedOnboarding.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.answer",
          options: {
            br: /*#__PURE__*/_jsx("br", {}),
            languageLink: /*#__PURE__*/_jsx(LinkWrapper, {
              href: languageHref,
              external: true,
              onClick: () => handleLinkClick('hsocV2.whatSupport.languageOffering', languageHref),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.languageOffering"
              })
            }),
            communityLink: /*#__PURE__*/_jsx(LinkWrapper, {
              href: communityHref,
              external: true,
              onClick: () => handleLinkClick('hsocV2.whatSupport.hubSpotCommunity', communityHref),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.hubSpotCommunity"
              })
            }),
            academyLink: /*#__PURE__*/_jsx(LinkWrapper, {
              href: academyHref,
              external: true,
              onClick: () => handleLinkClick('hsocV2.whatSupport.hubSpotAcademy', academyHref),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.hubSpotAcademy"
              })
            }),
            kbLink: /*#__PURE__*/_jsx(LinkWrapper, {
              href: kbHref,
              external: true,
              onClick: () => handleLinkClick('hsocV2.whatSupport.hubSpotKnowledgeBase', kbHref),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.hubSpotKnowledgeBase"
              })
            })
          }
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.whatSupport', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.question')
      })]
    })
  });
};
export default HsocV2Faqs;